<template>
  <div class="message-input-box">
    <div class="input-tools">
      <i slot="reference" class="icon_face" @click="showFace" title="表情"></i>
      <i slot="reference" class="icon_img" @click="uploadImg(1)" title="表情">

      </i>
      <input class="uploadfile" :value="uploadfileUrl" type="file" name="image" @change="fileImage" ref="filElem"
             style="display: none"
             accept="image/*"/>
    </div>
    <el-input type="textarea" @focus="hidePanel" resize="none" :autosize="{ minRows: 5, maxRows: 5}"
              placeholder="请输入..." v-model="textArea" v-on:keyup.native="keyUp">
    </el-input>

    <div class="footer-tools" @click="hidePanel">
      <el-button size="mini" :disabled="nowSwitchId?false:true" type="primary" @click="sendMessage" class="send-button">
        发送/Send
      </el-button>
    </div>
    <div class="faceBox" id="myPanel" v-if="showFaceTip">
      <div class="faceList">
        <span class="items" v-for="(item, index) in emojiList" @click="sendFace(item.imgUrl)">
          <img :src="item.imgUrl"/>
          <p>{{item.mean}}</p>
        </span>
      </div>
      <div class="faceTabs">
        <span v-for="(item, index) in emoji" :class="emojiIndex==index?'active':''"
              @click="tabs(index)">{{item.theme_name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Bus from '@/assets/eventBus'
  import {
    sendWebsocket
  } from "@/utils/websocket";
  import {
    gotoBottom
  } from '@/assets/tools'
  import {
    getEmojis,
    uploadImg
  } from '@/api/customer'
  import {getToken} from "../api/commonMG";
  import {uploadFile} from "../utils/util";

  export default {
    data() {
      return {
        textArea: '',
        emoji: [],
        emojiIndex: 0,
        emojiList: [],
        showFaceTip: false,
        gotoBottom: gotoBottom,
        file: '',
        uploadfileUrl: ''
      }
    },
    props: {
      // 联系人列表
      concats: {
        type: Array
      },
      // 当前选择的ID
      nowSwitchId: {
        type: String
      },
      // 当前用户
      localInfo: {
        type: Object
      }
    },
    mounted() {
      // 表情
      this.loadEmojis();
    },

    methods: {
      /**
       * 表情
       */
      loadEmojis() {
        getEmojis().then(res => {
          console.log(res);
          this.emoji = res.content;
          this.emojiList = res.content[this.emojiIndex].emoInfoList
        })
      },
      showFace() {
        this.showFaceTip = !this.showFaceTip
      },
      tabs(index) {
        this.emojiIndex = index;
        this.emojiList = this.emoji[index].emoInfoList
      },
      /**
       * 时间格式化
       */
      formatTime(time) {
        var date = new Date()
        var hours = date.getHours()
        var minutes = date.getMinutes()
        var seconds = date.getSeconds()
        hours = hours < 10 ? `0${hours}` : hours
        minutes = minutes < 10 ? `0${minutes}` : minutes
        seconds = seconds < 10 ? `0${seconds}` : seconds
        if (this.formatFullYearMonthDay(date) === this.formatFullYearMonthDay(nowDate)) {
          return `${hours}:${minutes}:${seconds}`
        } else {
          return `${this.formatFullYearMonthDay(date, false, '-')} ${hours}:${minutes}:${seconds}`
        }
      },
      /**
       * 时间
       */
      nowTime() {
        return new Date().getTime();
      },
      // 上传图片
      uploadImg() {
        // 触发一个自定义事件
        this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
      },
      fileImage(e) {
        let that = this;
        let file = e.target.files[0];
        this.file = file;
        // 校验图片格式
        var rFilter = /^(image\/jpeg|image\/jpg|image\/png|image\/gif)$/i; // 检查图片格式
        if (file && !rFilter.test(file.type)) {
          that.$message.error('不支持的格式，请重新上传！');
          that.$refs.filElem.value = null;
          // $utilMsg.warn("不支持的格式，请重新上传！");
          return false;
        }
        // 判断图片是否大于10M
        if (file && file.size >= 10 * 1024 * 1024) {
          that.$refs.filElem.value = null;
          return that.$message.error('上传图片超过10M，请重新选择！');
          //return $utilMsg.warn("上传图片过大，请重新选择");
        }
        if (file)
          this.upImgUrl(file)
      },
      upImgUrl(file) {
        let that = this;
        let params = new FormData();
        params.append("image", file);
        Bus.$emit('MESSAGE', {loading: true, isImg: true});
        //先根据后台获取token
        getToken().then(res => {
          if (res) {
            let result = uploadFile(res, file, false);
            result.then(res => {
              if (res.data.success) {
                Bus.$emit('MESSAGE', {loading: false, isImg: true})
                that.sendImg(res.data.content.file.fileUrl);
              } else {
                Bus.$emit('MESSAGE', {loading: false, isImg: true})
                that.$message.error(res.data.msg);
              }
              that.$refs.filElem.value = null;
            })
          }
        });
        // uploadImg(params).then(res => {
        //   if (res.success) {
        //     Bus.$emit('MESSAGE', {loading:false,isImg:true})
        //     that.sendImg(res.attrs.file_url);
        //   } else {
        //     Bus.$emit('MESSAGE', {loading:false,isImg:true})
        //     that.$message.error(res.msg);
        //   }
        //   that.$refs.filElem.value = null;
        // })
      },
      /**
       * 消息过滤
       */
      textAreaTran() {
        return this.textArea.replace(/\n/g, '')
      },

      /**
       * 检测空白
       */
      blankTesting() {
        if (this.textArea.replace(/\s+/g, '') === '') {
          this.$alert('不能发送空白消息', '提示', {
            confirmButtonText: '确定'
          })
          return false
        }
        return true
      },

      /**
       * 按Enter发送消息
       */
      keyUp(event) {
        this.showFaceTip = false;
        if (event.key === 'Enter') {
          this.sendMessage()
        }
      },
      hidePanel: function (event) {
        var sp = document.getElementById("myPanel");
        if (sp) {
          if (!sp.contains(event.target)) { //这句是说如果我们点击到了id为myPanel以外的区域
            this.showFaceTip = false;
          }
        }
      },
      //发送图片
      sendImg(url) {
        let that = this;
        let msg = {
          'from_id': this.localInfo.sid,
          'target_id': this.nowSwitchId,
          'media_url': url,
          'msg_type': 'image',
          'from_platform': 'web',
          'msg_ctime': this.nowTime(),
          'isText': true,
          'commonMessageType': 2171,
        };
        if (this.nowSwitchId) {
          Bus.$emit('MESSAGE', msg);
          sendWebsocket(JSON.stringify(msg));
        } else {
          this.$alert('不能跟空气聊天', '提示', {
            confirmButtonText: '确定'
          })
        }
      },
      //发送表情
      sendFace(url) {
        let that = this;
        // let faceUrl = '[face-' + url + ']';
        let msg = {
          'from_id': this.localInfo.sid,
          'target_id': this.nowSwitchId,
          'media_url': url,
          'msg_type': 'image',
          'from_platform': 'web',
          'commonMessageType': 2171,
          'isText': true,
          'msg_ctime': this.nowTime()
        };
        if (this.nowSwitchId) {
          Bus.$emit('MESSAGE', msg);
          sendWebsocket(JSON.stringify(msg));
          this.showFaceTip = false;
        } else {
          this.$alert('不能跟空气聊天', '提示', {
            confirmButtonText: '确定'
          })
        }
      },
      /**
       * 发送消息
       */
      sendMessage(content) {
        let msg = {
          'from_id': this.localInfo.sid,
          'target_id': this.nowSwitchId,
          'message': this.textAreaTran(),
          'msg_type': 'text',
          'from_platform': 'web',
          'commonMessageType': 2171,
          'msg_ctime': this.nowTime(),
          'isText': true
        };
        if (this.blankTesting() && this.nowSwitchId) {
          // 传递至同级
          Bus.$emit('MESSAGE', msg);
          sendWebsocket(JSON.stringify(msg));
          // 消息清空
          this.textArea = '';
        }
        if (this.nowSwitchId === '') {
          this.$alert('不能跟空气聊天', '提示', {
            confirmButtonText: '确定'
          })
        }
      }
    }
  }
</script>

<style>
  .message-input-box {
    height: 200px;
    background-color: rgba(255, 255, 255, 0.85);
    border-top: 1px solid #ebeef5;
    position: relative;
  }

  .message-input-box .faceBox {
    position: absolute;
    height: 240px;
    width: 380px;
    left: 10px;
    top: -251px;
    border-radius: 10px;
    box-shadow: 0 0 10px #ccc;
    background-color: #fff;
  }

  .message-input-box .faceBox .faceTabs {
    height: 20px;
    line-height: 20px;
    padding: 10px;
    border-top: 1px solid #ebeef5;
  }

  .message-input-box .faceBox .faceTabs span {
    margin-right: 10px;
    display: inline-block;
    font-size: 13px;
    color: #666;
    cursor: pointer;
  }

  .message-input-box .faceBox .faceTabs span:hover,
  .message-input-box .faceBox .faceTabs span.active {
    color: #409EFF;
  }

  .message-input-box .faceBox .faceList {
    height: 200px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
    padding: 0 10px;
  }

  .message-input-box .faceBox .faceList .items {
    width: 16.6%;
    margin: 15px 0 0;
    text-align: center;
    cursor: pointer;
  }

  .message-input-box .faceBox .faceList .items p {
    font-size: 12px;
    color: #888;
  }

  .message-input-box .faceBox .faceList img {
    width: 32px;
    height: 32px;
  }

  .message-input-box .input-tools {
    position: relative;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .message-input-box .input-tools .upload-demo {
    display: inline;
  }

  .message-input-box .input-tools i {
    margin-left: 10px;
    color: #5e5e5e;
    font-size: 20px;
    cursor: pointer;
    display: inline-block;
    width: 25px;
    height: 25px;
  }

  .message-input-box .input-tools .icon_face {
    background: url(/static/img/icon_smile.png);
  }

  .message-input-box .input-tools .icon_img {
    background: url(/static/img/icon_picture.png);
  }

  .message-input-box .el-textarea .el-textarea__inner {
    padding: 5px 20px;
    border-radius: 0;
    border: 0;
    background-color: transparent;
  }

  .message-input-box .footer-tools {
    text-align: right;
  }

  .message-input-box .footer-tools .send-button {
    padding: 7px 10px;
    margin-right: 20px;
    background: #409EFF;
  }

  .face-pabel .face {
    display: inline-block;
    width: 20px;
    height: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/message-input.vue